<div class="corporate-attach-policy-component-wrap">
  <div class="text-center py-5">
    <button class="btn btn-primary" (click)="open()">Attach Policy</button>
  </div>
</div>
